import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=14b21262&scoped=true"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=14b21262&prod&lang=scss&scoped=true"
import style1 from "./indexNew.vue?vue&type=style&index=1&id=14b21262&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b21262",
  null
  
)

export default component.exports